import { getApp, initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, signOut } from "firebase/auth";
import { getVertexAI, getGenerativeModel } from "firebase/vertexai";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

import { CONFIRMATION_OF_CRITERIA_PT, VERIFY_USER_INPUT_PT } from "../constants";

const logOut = async (): Promise<void> => {
    try {
        await signOut(auth);
    } catch (e) {
        console.error("Firebase Error signing out: ", e);
    }
}

const {
    REACT_APP_FIREBASE_API_KEY,
    REACT_APP_AUTH_DOMAIN,
    REACT_APP_PROJECT_ID,
    REACT_APP_STORAGE_BUCKET,
    REACT_APP_MESSAGING_SENDER_ID,
    REACT_APP_APP_ID,
    REACT_APP_MEASUREMENT_ID
} = process.env;

const firebaseConfig = {
    apiKey: REACT_APP_FIREBASE_API_KEY,
    authDomain: REACT_APP_AUTH_DOMAIN,
    projectId: REACT_APP_PROJECT_ID,
    storageBucket: REACT_APP_STORAGE_BUCKET,
    messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
    appId: REACT_APP_APP_ID,
    measurementId: REACT_APP_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const firestoreDb = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const vertexAI = getVertexAI(firebaseApp);
const GEMINI_2_0_FLASH_MODEL = "gemini-2.0-flash-001";

// todo: Use json output for models
const verificationGemini = getGenerativeModel(vertexAI, {
    model: GEMINI_2_0_FLASH_MODEL,
    systemInstruction: VERIFY_USER_INPUT_PT,
});

const criteriaExtractionGemini = getGenerativeModel(vertexAI, {
    model: GEMINI_2_0_FLASH_MODEL,
    systemInstruction: CONFIRMATION_OF_CRITERIA_PT,
});

const googleAuthProvider = new GoogleAuthProvider();

const functions = getFunctions(firebaseApp);
// const functions = getFunctions(getApp());
// connectFunctionsEmulator(functions, "127.0.0.1", 5001);

export { firestoreDb, auth, googleAuthProvider, logOut, verificationGemini, criteriaExtractionGemini, functions };
